import * as React from 'react';
import {Button, Modal} from 'reactstrap';
import {GoogleApiWrapper, InfoWindow, Map, Marker} from 'google-maps-react';
import PrinterSettingsIcon from 'mdi-react/PrinterSettingsIcon';
import {printDiv} from '../../../../utils/utils';

class GeoModal extends React.PureComponent<any, any> {

    constructor(props) {
        super(props);
        this.state = {};
    }

    private onMarkerClick = (props, marker, e) => {
        this.setState({
            selectedPlace: props,
            activeMarker: marker,
            showingInfoWindow: true
        });
    };

    private onMapClick = (props) => {
        if (this.state.showingInfoWindow) {
            this.setState({
                showingInfoWindow: false,
                activeMarker: null
            });
        }
    };

    private handlePrint = () => {
        printDiv('ifmaptoprint', 'modal-content');
    };

    public render() {
        return (
            <Modal isOpen={this.props.isOpen} toggle={this.props.toggle} className='geo-modal'>
                {this.props.data ?
                    <>
                        <iframe id='ifmaptoprint' style={{height: '0px', width: '0px', position: 'absolute'}}/>
                        <Map
                            item={true}
                            xs={12}
                            style={{maxHeight: '75vh'}}
                            className='map-to-print'
                            google={this.props.google}
                            onClick={this.onMapClick}
                            zoom={17}
                            initialCenter={{
                                lat: Number(this.props.data.latitud),
                                lng: Number(this.props.data.longitud)
                            }}>
                            <>
                                <div className='data'>
                                    <p>{this.props.data.clienteId}</p>
                                    <p>{this.props.data.clienteRazonSocial}</p>
                                    <p>{this.props.data.direccion}</p>
                                    <p>{this.props.data.distrito}</p>
                                </div>
                                <div>
                                    <Button onClick={this.handlePrint}
                                            className='print-button'><PrinterSettingsIcon/></Button>
                                </div>
                            </>
                            <Marker
                                onClick={this.onMarkerClick}
                                title={this.props.data.direccion}
                                position={{lat: Number(this.props.data.latitud), lng: Number(this.props.data.longitud)}}
                                name={this.props.data.direccion}/>
                            <InfoWindow
                                marker={this.state.activeMarker}
                                visible={this.state.showingInfoWindow}>
                                <>
                                    {this.props.data.direccion}
                                </>
                            </InfoWindow>
                        </Map>
                    </> : null}
            </Modal>)
    }
}

export default GoogleApiWrapper({
    apiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY
})(GeoModal);


// WEBPACK FOOTER //
// ./src/components/pages/visicooler/clientes/geo-modal.tsx